import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CouponsActions,
  CreateCouponFailAction,
  CreateCouponRequestAction,
  CreateCouponSuccessAction,
  FetchCouponsFailAction,
  FetchCouponsRequestAction,
  FetchCouponsSuccessAction,
  RedeemCouponFailAction,
  RedeemCouponRequestAction,
  RedeemCouponSuccessAction,
  ResetCoupon,
  stateStatusType,
} from "./actionType";
import { CouponState, initialState } from "./state";

const fetchCouponRequest = (
  state: CouponState,
  action: FetchCouponsRequestAction
) => {
  return updateObject(state, {
    fetchCouponState: {
      ...state.fetchCouponState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchCouponSuccess = (
  state: CouponState,
  action: FetchCouponsSuccessAction
) => {
  return updateObject(state, {
    fetchCouponState: {
      ...state.fetchCouponState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      coupon: action.payload,
    },
  });
};

const fetchCouponFail = (
  state: CouponState,
  action: FetchCouponsFailAction
) => {
  return updateObject(state, {
    fetchCouponState: {
      ...state.fetchCouponState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      coupon: null,
    },
  });
};

//create
const createCouponRequest = (
  state: CouponState,
  action: CreateCouponRequestAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const createCouponSuccess = (
  state: CouponState,
  action: CreateCouponSuccessAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      data: action.payload,
    },
    fetchCouponState: {
      ...state.fetchCouponState,
      status: stateStatusType.SUCCESS,
    },
  });
};

const createCouponFail = (
  state: CouponState,
  action: CreateCouponFailAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchCouponState: {
      ...state.fetchCouponState,
      isLoading: false,
      status: stateStatusType.FAILED,
    },
  });
};
//redeem
const redeemCouponRequest = (
  state: CouponState,
  action: RedeemCouponRequestAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const redeemCouponSuccess = (
  state: CouponState,
  action: RedeemCouponSuccessAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      redeemData: action.payload,
    },
  });
};

const redeemCouponFail = (
  state: CouponState,
  action: RedeemCouponFailAction
) => {
  return updateObject(state, {
    genericCouponState: {
      ...state.genericCouponState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const resetCoupon = (state: CouponState, action: ResetCoupon) => ({
  ...state,
  genericCouponState: { ...initialState.genericCouponState },
});

const fetchCouponReducer = (state = initialState, action: CouponsActions) => {
  switch (action.type) {
    case actionTypes.FETCH_COUPONS_REQUEST:
      return fetchCouponRequest(state, action);
    case actionTypes.FETCH_COUPONS_SUCCESS:
      return fetchCouponSuccess(state, action);
    case actionTypes.FETCH_COUPONS_FAIL:
      return fetchCouponFail(state, action);
    case actionTypes.CREATE_COUPON_REQUEST:
      return createCouponRequest(state, action);
    case actionTypes.CREATE_COUPON_SUCCESS:
      return createCouponSuccess(state, action);
    case actionTypes.CREATE_COUPON_FAIL:
      return createCouponFail(state, action);
    case actionTypes.REDEEM_COUPON_REQUEST:
      return redeemCouponRequest(state, action);
    case actionTypes.REDEEM_COUPON_SUCCESS:
      return redeemCouponSuccess(state, action);
    case actionTypes.REDEEM_COUPON_FAIL:
      return redeemCouponFail(state, action);
    case actionTypes.RESET_COUPON:
      return resetCoupon(state, action);
    default:
      return state;
  }
};

export default fetchCouponReducer;
